import React from "react";
import { connect } from "react-redux";
import { Divider, Table } from "antd";
import "./reportGrid.css";
import { DATE_FORMAT } from "../../constants/dateConstants";
import moment from "moment";
import AdvancedGroupingTable from "./AdvancedGroupingTable";
import DrillDownTarget from "../DrillDownTarget";
import ResizableTitle from "./ResizableTitle";
import { autoFitWidth, isArrayField, resolveColumnWidth, INDENT_PADDING_PX, INDENT_MAX_COLUMNS } from "./columnWidths";
function dev(arr) {
  // Creating the mean with Array.reduce
  let mean =
    arr?.reduce((acc, curr) => {
      return acc + curr;
    }, 0) / arr?.length;

  // Assigning (value - mean) ^ 2 to every array item
  arr = arr?.map((k) => {
    return (k - mean) ** 2;
  });

  // Calculating the sum of updated array
  let sum = arr?.reduce((acc, curr) => acc + curr, 0);

  // Calculating the variance
  // let variance = sum / arr.length

  // Returning the Standered deviation
  return Math.sqrt(sum / arr?.length);
}

function median(values) {
  if (values?.length === 0) return 0;

  values?.sort(function (a, b) {
    return a - b;
  });

  var half = Math.floor(values?.length / 2);

  if (values?.length % 2) return values[half];

  return (values[half - 1] + values[half]) / 2.0;
}

function ver(list) {
  // var sum = 0;
  var total = list?.reduce(function (a, b) {
    return a + b;
  });

  var mean = total / list?.length;

  function var_numerator(value) {
    return (value - mean) * (value - mean);
  }
  var variance = list?.map(var_numerator);

  variance = variance?.reduce(function (a, b) {
    return a + b;
  });

  return variance / list?.length;
}

// var aggData = [
//     { "id": 1627206254638, "dataType": "text", "aggType": "sum", filterType: "equal", fieldName: "timepoint" },
//     { "id": 1627206260443, "dataType": "text", "aggType": "sum", filterType: "equal", fieldName: "seeing" },
//     { "id": 1627206260443, "dataType": "text", "aggType": "maximum", filterType: "equal", fieldName: "temp2m" },
//     { "id": 1627206260443, "dataType": "text", "aggType": "sum", filterType: "equal", fieldName: "temp2m" },
//     { "id": 1627206260443, "dataType": "text", "aggType": "median", filterType: "equal", fieldName: "lifted_index" }
// ]

//console.log(result);

class ReportGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      result: {
        sum: [],
        average: [],
      },
      fieldList: [],
      // set when a drill-down opens in a Modal or Side Panel instead of a tab
      drillDownTarget: null,
      /* Widths dragged during THIS session, keyed by dataIndex. Held here
               rather than pushed straight to redux so the column tracks the
               pointer without a dispatch per frame - see handleColumnResizeEnd
               for the one write that does happen, on release. */
      columnWidths: {},
    };

    // this.onCalculationValue = this.onCalculationValue.bind(this);
  }

  /* ── COLUMN WIDTHS ───────────────────────────────────────────────────────
       Cells are clipped to one line (`ellipsis` on each column), which keeps
       every row the same height but hides the tail of a long value. Dragging a
       header's right edge is the way back to it. See ./columnWidths.js for how a
       width is resolved and ./ResizableTitle.js for the grip itself.

       Only the editor passes `onColumnResize`, so only the editor saves. Every
       other view still lets the reader drag - it costs nothing and helps - but
       the widths are theirs alone and a reload returns to the saved ones. */

  // mid-drag: local only, so this re-renders the table and nothing else
  handleColumnResize = (dataIndex, width) => {
    this.setState((prev) => ({
      columnWidths: { ...prev.columnWidths, [dataIndex]: width },
    }));
  };

  // on release: hand the final width up to be persisted, once
  handleColumnResizeEnd = (dataIndex, width) => {
    if (typeof this.props.onColumnResize === "function") {
      this.props.onColumnResize(dataIndex, width);
    }
  };

  // the field config behind a column, for its width and its formatting
  getFieldForColumn = (dataIndex) =>
    (this.props?.availableFields || []).find((af) => (af?.dataIndex ?? af?.fieldName ?? af?.title) === dataIndex);

  // double-click on the grip: size to the content, like a spreadsheet
  handleColumnAutoFit = (dataIndex) => {
    const field = this.getFieldForColumn(dataIndex);
    const width = autoFitWidth({
      title: field?.fieldDisplayName ?? field?.fieldName ?? field?.title ?? dataIndex,
      dataIndex,
      rows: this.props?.reportData?.data || [],
      field,
    });
    this.handleColumnResize(dataIndex, width);
    this.handleColumnResizeEnd(dataIndex, width);
  };

  /* Ant's hook for replacing the header cell. Held as one stable object rather
       than rebuilt inline: a fresh `components` on every render remounts every
       <th>, which would drop the pointer capture halfway through a drag. */
  tableComponents = { header: { cell: ResizableTitle } };

  Capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  onCalculationValue = (aggrigationtype, field) => {
    if (aggrigationtype === "sum") {
      return this.props?.reportData?.data?.reduce((a, curr) => Number(a) + Number(curr[field]), 0)?.toFixed(2);
    } else if (aggrigationtype === "average") {
      return (
        this.props?.reportData?.data?.reduce((a, curr) => Number(a) + Number(curr[field]), 0) /
        this.props?.reportData?.data?.length
      )?.toFixed(2);
    } else if (aggrigationtype === "minimum") {
      return Math.min(...this.props?.reportData?.data?.map((o) => Number(o[field])));
    } else if (aggrigationtype === "maximum") {
      return Math.max(...this.props?.reportData?.data?.map((o) => Number(o[field])));
    } else if (aggrigationtype === "count") {
      return this.props?.reportData?.data?.length;
    } else if (aggrigationtype === "standarddeviation") {
      return dev(this.props?.reportData?.data?.map((o) => Number(o[field])));
    } else if (aggrigationtype === "variance") {
      return ver(this.props?.reportData?.data?.map((o) => Number(o[field])));
    } else if (aggrigationtype === "median") {
      return median(this.props?.reportData?.data?.map((o) => Number(o[field])));
    }
    return null;
  };

  componentDidMount() {
    if (this.props?.aggRowBuilders) {
      this.setState({
        result: this.props?.aggRowBuilders?.reduce((r, a) => {
          r[a?.aggType] = r[a?.aggType] || [];
          r[a?.aggType]?.push(a);
          return r;
        }, Object.create(null)),
      });
    } else {
    }
  }

  getNestedTableColumns = (items) => {
    if (Boolean(items?.length)) {
      return Object.keys(items[0])
        ?.filter((item) => typeof items[0][item] === "number" || typeof items[0][item] === "string")
        ?.map((item) => {
          return {
            title: item,
            dataIndex: item,
            key: item,
          };
        });
    }
    return "";
  };

  /* ── DRILL DOWN ──────────────────────────────────────────────────────────
       Reads the config saved per widget in resources[].drillDowns. Supports the
       original HyperLink shape (linkedItemKey + parameterKeys) and the newer one
       (cellColumns with specific values, mappings, external service URLs).
       Modal / Side Panel render the target in place; external URLs always open.  */

  // the rule that applies to a whole column, or null
  getColumnDrillDown = (dataIndex) => {
    const drillDowns = this.props?.drillDowns;
    if (!drillDowns || !drillDowns.length) return null;
    return (
      drillDowns.find((d) => {
        if (d?.enabled === false) return false;
        if (d?.triggerType === "cell" && d?.cellColumns?.length) {
          return d.cellColumns.some((c) => {
            if (c.column !== dataIndex) return false;

            // OLD SHAPE: cells carry the values to match, so the column is only
            // clickable where one of those values was configured.
            const configuredCells = (c.cells || []).filter((cell) => String(cell?.value ?? "").trim() !== "");
            if (configuredCells.length) return true;

            // CURRENT SHAPE: no cell values - the whole column is linkable as
            // soon as the entry has a target to open.
            return (c.actionType || "report") === "external" ? Boolean(c.serviceUrl) : Boolean(c.reportId);
          });
        }
        if (d?.triggerType === "row") return false; // handled by the row handler
        return d?.linkedItemKey === dataIndex;
      }) || null
    );
  };

  // whether THIS cell value is clickable, and what it opens
  getCellDrillDownRule = (drillDown, dataIndex, text) => {
    if (!drillDown) return null;

    const fallback = {
      actionType: drillDown.targetType === "external" ? "external" : "report",
      reportId: drillDown.reportId,
      serviceUrl: drillDown.serviceUrl,
    };

    if (drillDown.triggerType !== "cell" || !drillDown.cellColumns?.length) return fallback;

    const column = drillDown.cellColumns.find((c) => c.column === dataIndex);
    if (!column) return null;

    const configuredCells = (column.cells || []).filter((c) => String(c?.value ?? "").trim() !== "");

    /* CURRENT SHAPE - no cell values: every value in this column is a link and the
           target sits on the column entry. `targetField` is the field in the target report
           holding this value; it is carried through here so the href can filter by it. */
    if (!configuredCells.length) {
      // a blank cell has no value to open the target with, so leave it as plain text
      if (String(text ?? "").trim() === "") return null;

      const actionType = column.actionType || fallback.actionType;
      const reportId = column.reportId || drillDown.reportId;
      const serviceUrl = column.serviceUrl || drillDown.serviceUrl;
      const hasTarget = actionType === "external" ? Boolean(serviceUrl) : Boolean(reportId);
      if (!hasTarget) return null;

      // sourceColumn is read back off the row so the value we send is the raw
      // stored value, not whatever the cell happens to be formatted as
      return {
        actionType,
        reportId,
        serviceUrl,
        // Cell Click keeps its URL per entry, so its parameter map lives there too
        urlParamMap: column.urlParamMap,
        targetField: column.targetField,
        sourceColumn: column.column,
      };
    }

    /* OLD SHAPE - only the configured cell values are clickable. Kept so boards saved
           before the change keep behaving the way they were set up. */
    const matched = configuredCells.find((c) => String(c.value).trim() === String(text ?? "").trim());
    return matched
      ? {
          actionType: matched.actionType || fallback.actionType,
          reportId: matched.reportId || drillDown.reportId,
          serviceUrl: matched.serviceUrl || drillDown.serviceUrl,
        }
      : null;
  };

  /* What travels to the target report.
       Current shape: the clicked column's value, keyed by the field in the TARGET report
       that holds it (the foreign key the user picked). `clientFilter` marks it as ours so
       the target filters its loaded rows by it - see HtmlReportWidgets.applyDrillDownFilter.
       Old boards have no targetField and keep the previous behaviour untouched: mappings
       rename the outgoing parameters, parameterKeys is the legacy pass-through. */
  getDrillDownParams = (drillDown, row, rule) => {
    if (rule?.targetField && rule?.sourceColumn) {
      return [{ key: rule.targetField, value: row?.[rule.sourceColumn], clientFilter: true }];
    }
    /* Row Click: the Column Mapping pairs. Tagged clientFilter for the same reason as
           above - `mappings` only ever came from this panel, never from a released
           version, so nothing existing depends on them being sent to the API instead. */
    return drillDown.mappings?.length
      ? drillDown.mappings
          .filter((m) => m.from && m.to)
          .map((m) => ({ key: m.to, value: row?.[m.from], clientFilter: true }))
      : (drillDown.parameterKeys || []).map((key) => ({ key, value: row?.[key] }));
  };

  buildDrillDownHref = (drillDown, rule, row) => {
    if (rule.actionType === "external") {
      const template = rule.serviceUrl || "";
      // a cell entry carries its own map; row click uses the drill-down level one
      const paramMap = rule.urlParamMap || drillDown.urlParamMap || {};
      return template.replace(/<([^<>\s/]+)>|\{([^{}\s/]+)\}/g, (whole, angle, curly) => {
        const fieldName = paramMap[angle || curly];
        const value = fieldName ? row?.[fieldName] : undefined;
        return value === undefined || value === null ? whole : encodeURIComponent(value);
      });
    }

    const params = this.getDrillDownParams(drillDown, row, rule);
    return `/report-html-view/${rule.reportId}?drillDownParams=${encodeURIComponent(JSON.stringify(params))}`;
  };

  // a row-level rule makes the whole row clickable instead of one column
  getRowDrillDown = () => {
    const drillDowns = this.props?.drillDowns;
    if (!drillDowns || !drillDowns.length) return null;
    return (
      drillDowns.find((d) => {
        if (d?.enabled === false) return false;
        if (d?.triggerType !== "row") return false;
        return d?.targetType === "external" ? Boolean(d?.serviceUrl) : Boolean(d?.reportId);
      }) || null
    );
  };

  // clicks that land on something interactive (a cell link, a popover, an input)
  // must not also trigger the row
  isInteractiveTarget = (element) =>
    Boolean(element?.closest?.("a, button, input, select, textarea, .ant-select, .ant-popover, .ant-checkbox"));

  // Modal / Side Panel render the target report in place. They can only do that for an
  // internal report - an external URL has to be opened, since we cannot render someone
  // else's page (and most sites refuse to be framed).
  opensInContainer = (drillDown, rule) =>
    (drillDown?.navigationType === "modal" || drillDown?.navigationType === "side-panel") &&
    rule?.actionType !== "external" &&
    Boolean(rule?.reportId);

  openDrillDownTarget = (drillDown, rule, row) => {
    const params = this.getDrillDownParams(drillDown, row, rule);
    this.setState({
      drillDownTarget: { mode: drillDown.navigationType, boardId: rule.reportId, params },
    });
  };

  closeDrillDownTarget = () => this.setState({ drillDownTarget: null });

  navigateToDrillDown = (drillDown, rule, row) => {
    const href = this.buildDrillDownHref(drillDown, rule, row);
    if (!href) return;
    const sameTab = drillDown.navigationType === "_self" || drillDown.openningOption === "_self";
    if (sameTab) {
      window.location.assign(href);
    } else {
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };

  handleRowDrillDownClick = (drillDown, row, event) => {
    if (this.isInteractiveTarget(event?.target)) return;
    const rule = {
      actionType: drillDown.targetType === "external" ? "external" : "report",
      reportId: drillDown.reportId,
      serviceUrl: drillDown.serviceUrl,
    };
    if (this.opensInContainer(drillDown, rule)) {
      this.openDrillDownTarget(drillDown, rule, row);
      return;
    }
    this.navigateToDrillDown(drillDown, rule, row);
  };

  // props spread onto whichever <Table> is rendered, empty when there is no row rule
  getRowInteractionProps = () => {
    const rowDrillDown = this.getRowDrillDown();
    if (!rowDrillDown) return {};
    return {
      rowClassName: "drill-down-row",
      onRow: (record) => ({
        onClick: (event) => this.handleRowDrillDownClick(rowDrillDown, record, event),
      }),
    };
  };

  renderDrillDownCell = (drillDown, rule, text, row) => {
    const isExternal = rule.actionType === "external";
    const inContainer = this.opensInContainer(drillDown, rule);
    const href = this.buildDrillDownHref(drillDown, rule, row);
    return (
      <a
        className={`drill-down-link${isExternal ? " drill-down-link--external" : ""}`}
        target={drillDown.openningOption === "_self" || drillDown.navigationType === "_self" ? "_self" : "_blank"}
        rel="noopener noreferrer"
        href={href}
        title={isExternal ? href : undefined}
        onClick={
          inContainer
            ? (event) => {
                // stays on the page - the report opens in a Modal / Side Panel
                event.preventDefault();
                this.openDrillDownTarget(drillDown, rule, row);
              }
            : undefined
        }
      >
        {this.getNestedView(text)}
      </a>
    );
  };

  getNestedView = (value) => {
    return Array.isArray(value) ? (
      Boolean(value?.length) ? (
        <Table
          columns={this.getNestedTableColumns(value)}
          dataSource={value}
          className="report-table"
          pagination={false}
          checked={false}
        />
      ) : (
        ""
      )
    ) : (
      /* React renders a boolean child as nothing, so a boolean column came out blank.
               That went unnoticed while booleans were excluded from availableFields; they
               are included now, so the value has to be printed. */
      <div>{typeof value === "boolean" ? String(value) : value}</div>
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props?.aggRowBuilders && prevProps?.aggRowBuilders !== this.props?.aggRowBuilders) {
      this.setState({
        result: this.props?.aggRowBuilders?.reduce((r, a) => {
          r[a?.aggType] = r[a?.aggType] || [];
          r[a?.aggType]?.push(a);
          return r;
        }, Object.create(null)),
      });
    }
    if (this.props?.availableFields && this.props?.availableFields !== prevProps?.availableFields) {
      const columns = this.props?.availableFields
        ? this.props?.availableFields?.map((af, i) => {
            return {
              title: af?.fieldDisplayName ?? af?.fieldName,
              dataIndex: af?.fieldName,
              key: `${af?.fieldName}_key${i}`,
              render: (text, val) =>
                af?.dataType === "date" ? (
                  <div>{moment(text)?.format(af?.format || DATE_FORMAT)}</div>
                ) : af?.dataType === "float" ? (
                  <div>{Number(text).toFixed(af.decimalPoints ? af.decimalPoints : 2)}</div>
                ) : (
                  this.getNestedView(text)
                ),
            };
          })
        : this.props?.reportData &&
          this.props?.reportData?.data &&
          Object.keys(this.props["reportData"]["data"][0])
            ?.filter(
              (item) =>
                typeof this.props.reportData.data[0][item] === "number" ||
                typeof this.props.reportData.data[0][item] === "string" ||
                Array.isArray(this.props.reportData.data[0][item]),
            )
            ?.map((item) => {
              return {
                title: item,
                dataIndex: item,
                key: item,
                render: (text, val) => this.getNestedView(text),
              };
            });
      this.setState({
        fieldList: [{ title: "", dataIndex: Math.random(), key: Math.random() }, ...columns],
      });
    }
  }

  /* One pager for every branch below.
       The count line sits at the bottom left ("Showing 1 to 10 of 275 entries"), the
       page buttons at the right - reportGrid.css does the placing; Ant renders the
       total as the first item of the same list. A table asked to hide its pager
       (Raw Data preview) still gets `false`. */
  getPaginationProps = () => {
    if (this.props.hidePagination) return false;
    return {
      showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
      /* The page-size picker sits beside that count on the left, not out at the
               end of the page buttons - reportGrid.css orders it there. Always offered,
               rather than only once the table passes Ant's 50-row threshold. */
      showSizeChanger: true,
      pageSizeOptions: ["10", "15", "20"],
      /* Three page buttons, an ellipsis, then the last page - Ant's own
               "less items" mode (it drops the neighbour buffer from 2 to 1).
               A thousand-row report was printing 1 2 3 4 5 … 100 next to the count
               and the size picker, which wrapped the footer onto a second line
               inside a widget card. */
      showLessItems: true,
      /* Ant labels each option "10 / page", and the label it renders is also what
               sits in the closed select. Blanked, so the control holds nothing but the
               number - 10, 15, 20 - and reportGrid.css writes the words around it:
               "Show" before the select, "entries" after. */
      locale: { items_per_page: "" },
    };
  };

  matched = (dataArr, a) => {
    return dataArr?.filter((b) => a === b?.fieldName);
  };

  // every row builder pointing at this column - more than one is allowed, they stack
  /* aggRowBuilders arrives flattened - one entry per aggregation - but every entry from
       the same Row Builder row carries that row's id and displayName. Regrouping on id
       gives back one summary row per builder row. */
  getRowBuilderGroups = () => {
    const builders = this.props?.aggRowBuilders || [];
    const groups = [];
    builders.forEach((builder) => {
      if (!builder) return;
      const key = builder.id ?? builder.displayName;
      const existing = groups.find((g) => g.key === key);
      if (existing) existing.builders.push(builder);
      else groups.push({ key, displayName: builder.displayName || "", builders: [builder] });
    });
    return groups;
  };

  /* No longer called: the summary row builds its cells from `columns` directly, which
       is what keeps it aligned with the header. Kept rather than removed - it is the only
       place mapping availableFields onto the keys actually present in the data. */
  getSelectedFieldsOnly = (values) => {
    return this.props.availableFields?.map((availabeField) => {
      return values.includes(availabeField.dataIndex) && availabeField.dataIndex;
    });
  };

  getFilterdValue() {
    return Object.keys(this.props.reportData.data[0])
      ?.filter(
        (item) =>
          typeof this.props.reportData.data[0][item] === "number" ||
          typeof this.props.reportData.data[0][item] === "string",
      )
      ?.filter((itm) => this.props.availableFields.findIndex((aa) => aa.dataIndex === itm) > -1);
  }

  render() {
    // if ( this.props.reportData && this.props.reportData.data && this.props.reportData.data.length === 0)  {
    //   return (<div></div>)
    // }

    let columns = this.props?.availableFields
      ? this.props.availableFields?.map((af, i) => {
          const dataIndex = af?.dataIndex ?? af?.title ?? i;
          const columnDrillDown = this.getColumnDrillDown(dataIndex);
          const plainTitle = af?.fieldDisplayName ?? af?.fieldName ?? af?.title ?? "";
          return {
            /* Opt-in hook for a decorated header - the board view uses it to hang a
               data-filter funnel off columns that have one, the way the host app
               does. Absent everywhere else (the editor included), so the header is
               the plain string it has always been. */
            title:
              typeof this.props.renderColumnTitle === "function"
                ? this.props.renderColumnTitle(af, plainTitle, dataIndex)
                : plainTitle,
            dataIndex: dataIndex,
            key: `key${i}_${af?.fieldName ?? af?.title ?? ""}`,
            render: (text, val) => {
              const rule = this.getCellDrillDownRule(columnDrillDown, dataIndex, text);

              return af.dataType === "date" ? (
                <div>{moment(text).format(af?.format || DATE_FORMAT)}</div>
              ) : af?.dataType === "float" ? (
                <div>{Number(text).toFixed(af.decimalPoints ? af.decimalPoints : 2)}</div>
              ) : rule ? (
                this.renderDrillDownCell(columnDrillDown, rule, text, val)
              ) : (
                /* title: the cell is clipped to one line, so hovering has to
                                   be able to show the rest. Ant sets `title` itself for the
                                   date and float branches above (their child is a string),
                                   but not here - getNestedView returns an element, and Ant
                                   only reads string children. Scalars only: an array cell
                                   holds a nested table, not text. */
                <span title={typeof text === "string" || typeof text === "number" ? String(text) : undefined}>
                  {this.getNestedView(text)}
                </span>
              );
            },
          };
        })
      : this.props?.reportData &&
        this.props.reportData?.data &&
        Object.keys(this.props.reportData.data[0])
          ?.filter(
            (item) =>
              typeof this.props.reportData.data[0][item] === "number" ||
              typeof this.props.reportData.data[0][item] === "string" ||
              Array.isArray(this.props.reportData.data[0][item]) === true,
          )
          ?.map((item) => {
            return {
              title: item,
              dataIndex: item,
              key: item,
              render: (text, val) => this.getNestedView(text),
            };
          });
    /* ── COLUMN NAMES STAY WHOLE ── (superseded, kept for context)
           With scroll.y the header is a separate table from the body, laid out from the
           widths Ant measures off the BODY - the header text is never measured. So a
           column of "0"s came out as wide as a zero and its name was cut to "Disc",
           "IsD", "Bra". A wide report never showed it because its values happened to be
           longer than its headings; a dashboard widget shows it immediately.

           The fix was a min-width per cell, taken from the length of the heading:

             const headerMinWidth = (title) =>
                 Math.min(340, Math.max(96, String(title ?? "").length * 8 + 34));

             columns = (columns || []).map((col) => {
                 const minWidth = headerMinWidth(col?.title);
                 return { ...col, onHeaderCell: () => ({ style: { minWidth } }),
                                  onCell: () => ({ style: { minWidth } }) };
             });

           Every column now declares an explicit width instead, which covers the same
           case (the width accounts for the heading, so a narrow column of "0"s still
           shows its name) and has to go: under the fixed table layout a cell min-width
           can beat the colgroup width, which pulls the header out of line with the
           body, and it would also stop a column being dragged below that floor.
           The formula itself lives on - it is the basis of the auto-fit in
           ./columnWidths.js, now measured against the values as well as the heading. */

    /* ── COLUMN WIDTHS ──
           Resolved per column: a width dragged this session, else the width the editor
           saved on the field, else auto-fit. `ellipsis` is what clips a long value to
           one line and keeps every row the same height - EXCEPT on a column holding
           arrays, where getNestedView draws a whole nested table that must not be
           squashed into a single line. */
    const widthRows = this.props?.reportData?.data || [];

    /* ── ALIGNMENT ──
           Columns read from the left, with one exception: on a table of MORE than
           two columns the last one centres, so the table closes on something other
           than a ragged right edge.

           The rule used to key off the first column as well - first left, last
           centred, the rest left - which on a two-column table meant the first and
           last columns WERE the whole table, so it reduced to "left column left,
           right column centred" and the two ends of the same header row disagreed
           with each other. Narrow tables are now handled by the indent below
           instead, and the centring is kept only where there are interior columns
           for it to close off. */
    const sourceColumns = columns || [];
    const lastColumnIndex = sourceColumns.length - 1;
    const alignmentFor = (index) => {
      if (sourceColumns.length > INDENT_MAX_COLUMNS && index === lastColumnIndex) return "center";
      return "left";
    };

    /* ── THE NARROW-TABLE INDENT ──
           A one- or two-column report does not come close to filling the card, and
           left-aligning it puts what little content there is hard against the left
           edge with the whole remainder blank - it reads as a table that has slid off
           to one side. These columns get extra left padding so the text sits in off
           the edge. See INDENT_PADDING_PX in ./columnWidths.js for the number and the
           CSS rule it has to agree with.

           Done as padding rather than as `align: "center"` because centring moves the
           heading and the values by DIFFERENT amounts - each centres on its own
           length - so the heading stops sitting over its column. Padding shifts both
           by the same distance. */
    const indentColumns = sourceColumns.length > 0 && sourceColumns.length <= INDENT_MAX_COLUMNS;

    columns = sourceColumns.map((col, index) => {
      const dataIndex = col?.dataIndex;
      const field = this.getFieldForColumn(dataIndex);
      const width = resolveColumnWidth({
        title: col?.title,
        dataIndex,
        rows: widthRows,
        field,
        draggedWidths: this.state.columnWidths,
      });

      return {
        ...col,
        /* The indent is paid for out of the column's width rather than out of its
                   text: without this the padding would eat into the space auto-fit sized
                   for the value and a heading that fitted would start truncating. */
        width: indentColumns ? width + INDENT_PADDING_PX : width,
        align: col?.align || alignmentFor(index),
        /* Ant puts a column's className on its <th> AND its <td>s, which is what
                   keeps the indented heading over its indented values. Appended rather
                   than assigned - `aggr-col` is already set on aggregation columns by
                   the board container. */
        className: [col?.className, indentColumns ? "rg-col-indent" : null].filter(Boolean).join(" ") || undefined,
        ellipsis: !isArrayField(field, widthRows, dataIndex),
        /* The resize props Ant hands to our header cell. Not DOM attributes -
                   ResizableTitle pulls them back out of the spread. */
        onHeaderCell: () => ({
          resizeKey: dataIndex == null ? "" : String(dataIndex),
          resizeWidth: width,
          onResize: this.handleColumnResize,
          onResizeEnd: this.handleColumnResizeEnd,
          onAutoFit: this.handleColumnAutoFit,
        }),
      };
    });

    /* ── ONE COLUMN SET, REPEATED PER PERIOD (PRM-518) ───────────────────────
       A comparison response carries the SAME fields for every period - only the
       figures differ - so the author picks their columns once and each period gets
       its own copy of them. Nothing extra to tick in the editor, and a report that
       gains a second range does not need its columns reconfigured.

       Period one reads the bare field names and the rest read the namespaced ones
       (see utils/arrayHelper); the clone only has to point its dataIndex at the
       right key, because Ant feeds `render` whatever that resolves to.

       Done BEFORE columnWidthSum so scroll.x counts the copies - folding it in after
       would size the table for a third of the columns it draws. */
    const periodKeys = this.props.periodKeys || [];

    if (periodKeys.length > 1) {
      /* The key column is rendered ONCE, outside the banners, and is not repeated
         per period - its value is the same for every period by definition, that
         being what matched the row. Only when a key is actually set: without one
         rows pair by position, and showing a single key column would then label one
         period's figures with another period's row. */
      const matchBy = this.props.matchBy;
      const keyColumn = matchBy ? columns.find((col) => col.dataIndex === matchBy) : null;
      const baseColumns = keyColumn ? columns.filter((col) => col.dataIndex !== matchBy) : columns;

      columns = periodKeys.reduce((all, key, periodIndex) => {
        const forPeriod = baseColumns.map((col) => {
          /* An OUTER join leaves one side null where a period had no row for this
             key. Rendered as a dash, not as 0: this data has real zeros (TotalVat,
             VatRate) and "we have no figure" is a different statement from "the
             figure is zero". */
          const withDash = (render) => (text, row, index) =>
            text === null || text === undefined ? (
              <span className="rg-no-value">—</span>
            ) : typeof render === "function" ? (
              render(text, row, index)
            ) : (
              text
            );

          // period one is already pointing at the bare names
          if (periodIndex === 0) return { ...col, periodKey: key, render: withDash(col.render) };

          const dataIndex = `${key}__${col.dataIndex}`;
          return {
            ...col,
            periodKey: key,
            render: withDash(col.render),
            dataIndex,
            key: `${key}_${col.key ?? col.dataIndex}`,
            /* Resizing is keyed by dataIndex, so a copy needs its own - otherwise
               dragging one period's column would drag the other's with it. */
            onHeaderCell: () => ({
              resizeKey: String(dataIndex),
              resizeWidth: col.width,
              onResize: this.handleColumnResize,
              onResizeEnd: this.handleColumnResizeEnd,
              onAutoFit: this.handleColumnAutoFit,
            }),
          };
        });

        return all.concat(forPeriod);
      }, []);

      if (keyColumn) columns = [keyColumn, ...columns];
    }

    /* scroll.x is the exact sum, so the header table and the body table lay their
           colgroups out identically and the two stay aligned while panning.

           Falls back to "max-content" when it comes to nothing - a table asked to
           render with an empty column list would otherwise be handed scroll.x: 0,
           which Ant treats as a real width of zero rather than as "no width given". */
    const columnWidthSum = columns.reduce((total, col) => total + (Number(col.width) || 0), 0);
    const tableWidth = columnWidthSum > 0 ? columnWidthSum : "max-content";

    /* ── PERIOD BANNERS (PRM-518) ────────────────────────────────────────────
       A comparison response gives columns namespaced by the response key they came
       from - Result__TotalSales, Result2__TotalSales (see utils/arrayHelper). Ant
       draws a two-level header from nested columns, so each period's columns are
       collected under one banner.

       The banner text is the name the report's author typed in the editor, handed
       down as `periodLabels`; it falls back to the response key so the table is
       still readable before anyone has named anything.

       Columns with no namespace stay at the top level and sit to the LEFT of the
       banners - they belong to the report rather than to either period.

       Deliberately AFTER columnWidthSum: a group column has no width of its own, so
       folding first would have made the sum (and therefore scroll.x) collapse. */
    /* Each period's copies collected under one banner. The period is read off the
       column itself - set when the copies were made above - rather than parsed back
       out of the dataIndex, so a field whose real name happens to contain the
       separator cannot be mistaken for a namespaced one. */
    if (periodKeys.length > 1) {
      const labels = this.props.periodLabels || {};

      const ungrouped = columns.filter((col) => !col.periodKey);

      columns = ungrouped.concat(
        periodKeys.map((key, i) => ({
          title: labels[key] || key,
          key: `rg_period_${key}`,
          // one accent per period, matching the editor's Display Date Filter box
          className: `rg-period rg-period--${i % 4}`,
          children: columns.filter((col) => col.periodKey === key),
        })),
      );
    }

    /* The summary row used to need a blank leading column to hold its label, which
           left a wide empty gap before the first real column on every table that had a
           Row Builder. The label now sits under the first real column instead - it is a
           footer for the table, not a column of it - so the extra column is gone.
           (Was: displayColumns = [{ title: "", dataIndex: Math.random() }, ...columns].) */

    /* A pinned summary is rendered by Ant in a SEPARATE table from the body, and a
           table can only line its columns up with another one through matching colgroup
           widths. With none declared, that second table sized itself to its own short
           contents and collapsed - "Totals" came out as one letter per line.

           So the table that carries a summary declares a width for every column, and
           scroll.x is their exact sum. Tables without Row Builders are untouched and
           keep sizing themselves to their content. */
    /* Was `Math.max(SUMMARY_TABLE_COL_WIDTH, headerMinWidth(col.title))` with
           SUMMARY_TABLE_COL_WIDTH = 180, because a summary table had no widths of its
           own to fall back on. Every column now arrives with one, and forcing a 180px
           floor on top of it would mean a column dragged to 100px silently sprang back
           - so the resolved width is used as-is here too. The label and the totals are
           `white-space: nowrap` (reportGrid.css), so a narrow column overflows its text
           rather than breaking "Totals" into one letter per line. */

    /* A column that is being aggregated centres itself - header, rows and total
           together - so the total reads as the foot of that column rather than as a
           number floating under some other one. Columns with no builder keep the normal
           left alignment, so nothing moves on a table that has no totals. */
    const aggregatedFields = new Set(
      (this.props?.aggRowBuilders || []).map((builder) => builder?.fieldName).filter(Boolean),
    );

    const summaryTableColumns = columns.map((col) => ({
      ...col,
      ...(aggregatedFields.has(col.dataIndex) ? { align: "center" } : {}),
    }));
    const summaryTableWidth = tableWidth;

    return (
      <div className="report-grid">
        {this.props?.reportData?.data?.length ? (
          this.props?.aggRowBuilders && this.props?.aggRowBuilders.length > 0 ? (
            <Table
              columns={summaryTableColumns}
              dataSource={this.props.reportData.data}
              className="report-table"
              components={this.tableComponents}
              pagination={this.getPaginationProps()}
              /* Makes the body the scroll region rather than the whole
                               table, so the header stays at the top and the summary
                               stays at the bottom while the rows move between them.
                               Without it every part scrolled together and the totals
                               drifted out of view. */
              scroll={{ x: summaryTableWidth, y: 300 }}
              {...this.getRowInteractionProps()}
              summary={() => (
                <Table.Summary fixed>
                  {/* One summary row per Row Builder row: the row's Display
                                        Name labels it, and each of its aggregations lands in
                                        its own column. A different function = another row.

                                        Cells are built from `columns` so the row lines up with
                                        the header exactly. It used to be built from
                                        availableFields with the label pushed in front, which is
                                        why it needed a spare column to stay aligned. */}
                  {this.getRowBuilderGroups().map((group, gi) => (
                    <Table.Summary.Row className="tblTotal" key={`summary_row_${gi}`}>
                      {summaryTableColumns.map((col, i) => {
                        const builder = group.builders.find((b) => b.fieldName === col.dataIndex);
                        const value = builder ? this.onCalculationValue(builder.aggType, builder.fieldName) : null;

                        return (
                          <Table.Summary.Cell index={i} key={`summary_cell_${gi}_${i}`}>
                            {/* The label lives in the first column. An
                                                            aggregation on that same column keeps its
                                                            value here beside it rather than being
                                                            dropped. */}
                            {i === 0 ? <b>{group.displayName}</b> : null}
                            {value !== null ? (
                              <b className={i === 0 ? "summary-inline-value" : undefined}>{value}</b>
                            ) : null}
                          </Table.Summary.Cell>
                        );
                      })}
                    </Table.Summary.Row>
                  ))}
                </Table.Summary>
              )}
            />
          ) : this.props?.aggGroupBuilders?.advanced ? (
            <AdvancedGroupingTable
              columns={columns}
              dataSource={this.props.reportData.data}
              summaryData={[]}
              tableID={0}
              groupConfig={this.props.aggGroupBuilders}
            />
          ) : (
            // :<div>Hello</div>
            <Table
              columns={columns}
              dataSource={this.props.reportData.data}
              className="report-table"
              components={this.tableComponents}
              // Raw Data shows a short preview, so it asks for no pager
              pagination={this.getPaginationProps()}
              /* Same reason as the summary table above: scroll.y splits the
                               header out of the scrolling area, so the column names stay
                               put and the pager stays at the foot of the card while the
                               rows move between them. Without it Ant renders one
                               .ant-table-content that scrolls header and all, and the
                               widget card ended up doing the vertical scrolling instead
                               of the table.

                               x was "max-content", which kept the columns at their
                               natural content width (scroll.y alone makes the body 100%
                               wide, which would squeeze a wide report instead of letting
                               it scroll sideways). Every column now declares its own
                               width, so x is their exact sum instead - same effect, and
                               the header and body colgroups cannot disagree. Ant syncs
                               the header's scrollLeft to the body, so the two stay
                               aligned when panning across. The 300px is only a fallback:
                               inside a widget card the body is flexed to fill the card
                               instead (see boardWidgets.css / editorStyles.css). */
              scroll={{ x: tableWidth, y: 300 }}
              {...this.getRowInteractionProps()}
            />
          )
        ) : (
          <Table
            columns={columns}
            dataSource={[]}
            className="report-table"
            components={this.tableComponents}
            pagination={this.getPaginationProps()}
          />
        )}

        {/* Modal / Side Panel drill-down target */}
        {this.state.drillDownTarget ? (
          <DrillDownTarget
            open={Boolean(this.state.drillDownTarget)}
            mode={this.state.drillDownTarget.mode}
            boardId={this.state.drillDownTarget.boardId}
            params={this.state.drillDownTarget.params}
            onClose={this.closeDrillDownTarget}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(ReportGrid); // expose the HelloWorld component to other modules
